import { useState } from "react";
import { api, errorMsg } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AlertTriangle, Link2, Unlink } from "lucide-react";

export const RepararHuerfanaDialog = ({ plantilla, maestras, onClose, onDone }) => {
  const [maestraSel, setMaestraSel] = useState("");
  const [guardando, setGuardando] = useState(false);
  const abierto = !!plantilla;

  const motivo = plantilla?.maestra_inexistente
    ? "Su plantilla maestra ya no existe."
    : "Hereda de una plantilla padre que ya no existe.";

  const ejecutar = async (maestra_id) => {
    setGuardando(true);
    try {
      const { data } = await api.post(`/plantillas/${plantilla.id}/reasignar-maestra`, {
        maestra_id: maestra_id || null, limpiar_padres_huerfanos: true,
      });
      toast.success(maestra_id ? "Hija reasignada a la maestra" : "Plantilla desvinculada (ahora es manual)");
      onDone?.(); onClose?.();
    } catch (e) { toast.error(errorMsg(e)); }
    finally { setGuardando(false); }
  };

  return (
    <Dialog open={abierto} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent data-testid="reparar-huerfana-dialog" className="bg-white max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <AlertTriangle size={18} /> Reparar plantilla huérfana
          </DialogTitle>
          <DialogDescription>
            <span className="font-semibold text-foreground">{plantilla?.nombre}</span> — {motivo}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <p className="text-sm font-medium">Reasignar a otra maestra</p>
            <div className="flex gap-2">
              <Select value={maestraSel} onValueChange={setMaestraSel}>
                <SelectTrigger data-testid="reparar-maestra-select" className="flex-1">
                  <SelectValue placeholder="Elegí una maestra…" />
                </SelectTrigger>
                <SelectContent>
                  {(maestras || []).map((m) => (
                    <SelectItem key={m.id} value={m.id}>{m.nombre}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <Button data-testid="reparar-reasignar-btn" disabled={!maestraSel || guardando}
                onClick={() => ejecutar(maestraSel)}>
                <Link2 size={14} className="mr-1" /> Reasignar
              </Button>
            </div>
          </div>

          <div className="border-t border-border pt-3">
            <p className="text-sm text-muted-foreground mb-2">
              O desvinculala para dejarla como plantilla manual (conserva sus repuestos, sin maestra).
            </p>
            <Button data-testid="reparar-desvincular-btn" variant="outline" disabled={guardando}
              className="border-slate-300" onClick={() => ejecutar(null)}>
              <Unlink size={14} className="mr-1" /> Desvincular (dejar manual)
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
